import { EngineeringToolsIcon } from '@hcs/design-system';
import { AppSlugs } from '@hcs/types';
import { AppConfig } from '@hcs/types';

export const APP_CONFIG_ENG_TOOLS: AppConfig = {
  name: 'Engineering Tools',
  applicationKey: 'internal-eng-tools',
  type: 'internal',
  appSlugForEngagement: AppSlugs.EngTools,
  Icon: EngineeringToolsIcon,
  rootPath: '/eng-tools',
  descriptionLong: 'Tools for the HC Product Engineering Team',
  descriptionShort: 'Tools for the HC Product Engineering Team',
};

export const VIEW_PATHS_ENG_TOOLS = {
  GRAFANA_DASHBOARDS: 'grafana-dashboards',
  LOGS: 'logs',
  REPORT_REPAIR: 'report-repair',
} as const;
